import axios from 'axios';

export function getServerInfo() {
  return axios.get('/info');
}
